import * as marietta from '../../../..';
import { Dialog } from '../../../../core/view';
import { ITEM_MODE_NO } from '../../../Constants';
import * as THREE from 'three';
import { pix2D } from '../../../../LiDAR/graphicLibs/util/unit';
import { ThreeView } from '../../../../view3d/webcad';

/**
 * 建具シンボル指定ダイアログ
 */
export class WizardFittingSymbolSelection extends Dialog {
  target: marietta.webcad.item.Fitting;
  itemList: marietta.webcad.item.Fitting[];
  currentIndex: number = 0;

  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'fittingSymbolSelectionWizardDialog';
    let title: string = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Select Fitting Select'; break;
      default: title = '建具の種類を選択してください'; break;
    }
    let contents = '<div class="dialogFittingTypeBtns">\n';
    let obj: any = objItemMenuFitting;
    // メニューの追加
    for (let i = 0; i < obj.itemMenuGroup.length; i += 1) {
      for (let j = 0; j < obj.itemMenuGroup[i].children.length; j += 1) {
        //壁などのアイテムは含めない
        if( -1 < obj.itemMenuGroup[i].children[j].id.indexOf("fit01") ) continue;
        if( -1 < obj.itemMenuGroup[i].children[j].id.indexOf("fit02") ) continue;

        const elBtn = document.createElement('button');
        elBtn.setAttribute('class', 'dialogFittingTypeBtns')
        elBtn.setAttribute('value', obj.itemMenuGroup[i].children[j].id)
        const span1 = document.createElement('span');
        span1.setAttribute('class', 'jp');
        const span2 = document.createElement('span');
        span2.setAttribute('class', 'en');

        const elImg = document.createElement('img');
        const elImgEn = document.createElement('img');
        elBtn.classList.add('itemMenuBtn');
        elImg.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img);
        elImg.setAttribute('alt', obj.itemMenuGroup[i].children[j].name);
        elImgEn.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img_en);
        elImgEn.setAttribute('alt', obj.itemMenuGroup[i].children[j].name_en);

        span1.appendChild(elImg);
        span2.appendChild(elImgEn);
        elBtn.appendChild(span1);
        elBtn.appendChild(span2);

        contents += elBtn.outerHTML;
      }
    }

    contents += '</div>';

    const footer = '';

    this.createDialog(id, title, contents, footer);

    // イベント設定
    const btns = document.querySelectorAll('.dialogFittingTypeBtns button');
    for (let i = 0, len = btns.length; i < len; i += 1) {
      btns[i].addEventListener('click', this.onSelectType);
    }

    this.itemList = ThreeView.get().wizardManager.getTargetFitting();

    this.next();
  }

  /**
   * 種類ボタンが選択された
   */
  onSelectType = (e: MouseEvent) => {
    e.preventDefault();

    const type: string = <string>(<HTMLButtonElement>e.currentTarget).getAttribute('value');
    this.target.itemInfo.id = type;

    // itemInfoのコピー
    const itemInfo: marietta.webcad.collection.ItemInfoCollection = this.target.itemInfo.clone();
    itemInfo.id = type;

    // 名称変更
    const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(itemInfo.id);
    itemInfo.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);

    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
    // 削除
    this.target.deleteMe();

    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
    // 新しいアイテムの生成
    marietta.webcad.WebCADGlobal.itemManager.createItem(itemInfo);

    // ヒストリ
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    // 次に選択する部屋が存在しない時
    if (this.itemList.length == this.currentIndex) {
      this.finish();
      return;
    }

    this.next();
  }

  /**
   * 次の部屋へ
   */
  next = () => {
    marietta.WebCADGlobal.itemManager.currentItem = this.itemList[this.currentIndex] as marietta.webcad.item.Fitting; // 選択して分かりやすいようにする
    this.target = this.itemList[this.currentIndex] as marietta.webcad.item.Fitting;
    this.scrollPosition(this.itemList[this.currentIndex]); // 画面位置調節
    this.reposition(this.itemList[this.currentIndex]); // ダイアログと青線位置調節
    this.fittingSelect(this.itemList[this.currentIndex]); // 青枠・モーダル
    this.currentIndex += 1;
  }

  /**
   * 閉じるボタンが押された
   */
  close = () => {
    // モーダルの削除
    $("#modalBgForRoomSelect").hide();

    // 見積一覧更新
    marietta.webcad.WebCADGlobal.quotationItemList.createData(true);

    this.closeEvent();

    // wizardの終了
    ThreeView.get().wizardManager.end();
  }

  /**
   * override
   */
  closeEvent() {
    super.closeEvent();
  }

  /**
   * 次に選択する部屋が存在しない
   */
  finish() {
    marietta.WebCADGlobal.itemManager.currentItem = null;
    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
    // 青枠・モーダルの削除
    $("#modalBgForRoomSelect").hide();

    // wizardの終了
    ThreeView.get().wizardManager.end();
  }

  /**
   * 画面の位置調節
   */
  scrollPosition(room: marietta.webcad.item.Fitting): void {

      //部屋のバウンド
      const _bound = room.viewObj.getBoundingClientRect();
      const bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

      //scroll the screen if object not in the visible screen
      const view2D: HTMLElement = document.getElementById("webcad2dViewInner");
      const currentScrollPosition: marietta.core.Point = new marietta.core.Point(view2D.scrollLeft, view2D.scrollTop);
      let { top, left, bottom, right } = view2D.getBoundingClientRect();
      let scrollBarWidth = view2D.offsetWidth - view2D.clientWidth;
      right = right - left - scrollBarWidth;
      bottom = bottom - top - scrollBarWidth;
      const margin = 100;
      let xDiff = 0, yDiff = 0;
      if (bound.x < left) xDiff = bound.x - left - margin - bound.width;
      if (bound.y < top) yDiff = bound.y - top - margin - bound.height;

      if (bound.x > right) xDiff = bound.x - right + margin + bound.width;
      if (bound.y > bottom) yDiff = bound.y - bottom + margin + bound.height;

      marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(currentScrollPosition.x + xDiff, currentScrollPosition.y + yDiff);

  }

  /**
   * 青枠・モーダル
   */
  fittingSelect(fitting: marietta.webcad.item.Fitting): void {

      //異なる階の場合は、階を変更する
      const targetFloor: number = fitting.itemInfo.floor;
      if (targetFloor != marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
          marietta.webcad.WebCADGlobal.changeFloor(targetFloor);
      }

      const _bound = this.target.viewObj.getBoundingClientRect();
      let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

      //グレイを作る
      const path: string = "M0, 0" +
          "L" + window.innerWidth + ", 0" +
          "L" + window.innerWidth + "," + window.innerHeight +
          "L" + (bound.x + bound.width) + "," + window.innerHeight +
          "L" + (bound.x + bound.width) + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + bound.y +
          "L" + bound.x + "," + bound.y +
          "L" + bound.x + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + window.innerHeight +
          "L 0," + window.innerHeight +
          "L 0, 0Z";
      document.getElementById("modalBgForRoomSelect_fill")?.setAttribute("d", path);

      $("#modalBgForRoomSelect").show();
      $("#modalBg").hide();

    }

    /**
     * ダイアログの位置調節
     */
    reposition(target: marietta.webcad.item.Fitting): void {
      //ダイアログの位置
      //部屋が右半分のところにある
      const _bound = target.viewObj.getBoundingClientRect();
      let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

      const mybound = document.getElementById('fittingSymbolSelectionWizardDialog').getBoundingClientRect();
      const margin: number = 10;
      let posX: number = 0;
      let posY: number = 0;

      //X位置
      if (window.innerWidth / 2 < bound.x) {
          //基本的には右側
          posX = (bound.x + bound.width - window.innerWidth / 2 + mybound.width / 2) + margin;
          //枠を超えてしまう場合は左側に
          if (window.innerWidth / 2 - mybound.width / 2 < posX) {
              posX = bound.x - window.innerWidth / 2 - mybound.width / 2 - margin;
          }
      } else {
          //基本的には左側
          posX = bound.x - window.innerWidth / 2 - mybound.width / 2 - margin;
          //枠を超えてしまう場合は右側に
          if (posX < -window.innerWidth / 2 + mybound.width / 2) {
              posX = (bound.x + bound.width - window.innerWidth / 2 + mybound.width / 2) + margin;
          }
      }

      //Y位置
      //基本的には少し上に
      posY = bound.y - window.innerHeight / 2 + mybound.height / 2 - margin;
      //枠を超えてしまう場合は左側に
      if (posY < -window.innerHeight / 2 + mybound.height / 2) {
          posY = -window.innerHeight / 2 + mybound.height / 2 + 10;
      }
      if (window.innerHeight / 2 - mybound.height / 2 < posY) {
          posY = window.innerHeight / 2 - mybound.height / 2 - 10;
      }

      this.dialogPosition.x = posX;
      this.dialogPosition.y = posY;

      const cssTransform = 'translate(' + posX + 'px,' + posY + 'px)';
      $(this.viewObj).css({ transform: cssTransform });

  }


}
